module.exports = __webpack_public_path__ + "static/a10-ab5fed550997953fb097ffa9f1d441c7.png";